export default {
  mustBeChildField: false,
  canBeChildField: true,
  canBeParentField: true,
  canBeChildOfFieldTypes: ["account"],
  mappableFields: []
};
